import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import './Messages.css';
import Axios from 'axios';
import UserManager from '../../Core/UserManager';
import Config from '../../Core/Config.js';
import {framework,ui} from 'saffroncodejs';
import BimeManager from '../../Core/BimeManager';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faReply,faCalendar, faLink } from '@fortawesome/fontawesome-free-solid';
var PageManager = framework.PageManager ;

class MessageSingle extends React.Component {
  constructor(props) {
    super(props);
    var urlParams = PageManager.decodePageParams(props);
    this.currentId = this.encodeSodurId(urlParams[0]);
    this.currenttabId = this.encodeSodurId(urlParams[1]);
    this.state = {
        messages: [
            { companyName: 'شرکت سامان نگار ایرانیان', addressCo: 'تهران', faxCo: '84325', telCo: '84325', locationCo: '627.2238657537844 M' }
            ],
            bmMessages:[
                {}
            ],
            isLoading:true,
            isLoading2:true,
        };
        
        this.state.messages=[];
        this.state.bmMessages=[];
       
      this.loadTowMessages();  
}
loadTowMessages(){
    if(parseInt(this.currenttabId,10)===1){
        Axios.get(Config.domain_pic+"/GetUserQuestions?UserId="+UserManager.getUserToken()
        )
        .then((result) => { 
            var id=parseInt(this.currentId,10)
            console.log("result..find: ", JSON.stringify(result.data.QuestionReplies.find(u=>u.Id===id , 10))); 
            this.setState({ messages: result.data.QuestionReplies.find(u=>u.Id===id, 10), isLoading: false });
                Axios.get(Config.domain_pic+"/MarkMessageAsRead?QuestionReplyId="+parseInt(this.currentId,10)
                )
                .then((result2) => { 
                    console.log('dd',result2.data)
                    })
        })
    }
    else{
        Axios.post(BimeManager.reactRedirectDomain,
            BimeManager.makeBody("/NovinInsuranceServices/Not/api/Not/Notification",
    
                { codeMelli: UserManager.MelliCode() }
            ),
            BimeManager.header())
            .then((result) => {
                var id2=parseInt(this.currentId,10)
                console.log("result.data : ", result.data);
                    this.setState({ bmMessages: result.data.find(u=>u.Id===id2, 10), isLoading2: false })
                
            })
            .catch((error) => { alert(error) })
    }
   
}
encodeSodurId(encodedId)
    {
        return encodedId;
    }

    componentWillReceiveProps(props)
    {
        var urlParams = PageManager.decodePageParams(props);
        this.currentId = this.encodeSodurId(urlParams[0]);
        this.currenttabId = this.encodeSodurId(urlParams[0]);
       
    }
    
  render() {
    const { messages } = this.state;
    const {bmMessages}=this.state;
    return (
        <div>
            <br />
            <Container className="alignRight">
                <Row>
                    <Col sm="12" className="alignRight title">
                        <h4>پیام </h4>
                    </Col>
                </Row>
                {this.currenttabId==='1'?
                    (!this.state.isLoading) ?<Row className="box_shadow">
                        <Col sm='12'>
                            {messages.ReplyText!==null?<span className="reply"><h5 className="subject_message">{messages.Subject}</h5><br/><span className="question"><h6 className="header_message"><strong>عنوان و متن پیشنهاد شما :</strong></h6> 
                            <hr/>
                            <span >
                                    <p className="header_message"><strong>عنوان پیشنهاد ارسالی شما : </strong>{messages.Subject}</p>
                                    <p className="header_message"><strong>متن پیشنهاد ارسالی شما : </strong>
                                        {messages.Body}
                                    </p>
                                    </span>
                                </span>
                            <h5 className="header_message"><FontAwesomeIcon icon={faReply} className="fontinMessage" /><strong>پاسخ مدیر  :</strong><br/><br/>{messages.ReplyText}</h5>
                            {(messages.ImageName)?
                            <img alt="" src={'http://mobapp.novininsurance.com/UploadImages/TQuestionReply/'+messages.ImageName} className="thumbnail-post" />
                            : <span></span>
                            } 
                            </span>
                            :
                            <span><h5 className="subject_message">{messages.Subject}</h5>
                            {(messages.ImageName)?
                                <img alt="" src={'http://mobapp.novininsurance.com/UploadImages/TQuestionReply/'+messages.ImageName} className="thumbnail-post" />
                                : <span></span>
                            } 
                            <p>
                                {messages.Body}
                            </p>
                            </span>
                        }
                        </Col>
                    </Row>
                    :<ui.Preloader />
                :
                (!this.state.isLoading2)?<Row className="box_shadow">
                        <Col sm='12'>
                            {
                            <span>
                           <p>
                         <small><FontAwesomeIcon icon={faCalendar} className="fontinMessage" /> {bmMessages.RegDate}</small> 
                            
                          </p>
                          <p>
                            {bmMessages.Content}
                          </p>
                           <a href={bmMessages.RelatedLink} target="_blank" className="btn btn-secondary btn btn-secondary btn-link" >{bmMessages.RelatedLinkTitle}</a> 
                            </span>
                        }
                        </Col>
                    </Row>
                    :<ui.Preloader />
                }
                
            </Container>
            <br />
        </div>
    );
  }
}
export default MessageSingle;


// WEBPACK FOOTER //
// ./src/components/Messages/MessageSingle.js